import { Button, Card, CardContent, Checkbox, FormControlLabel } from "@material-ui/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import MaterialTableComponent from "../../NestedComponents/widgets/materialTable";
import adminService from "../../Services/adminService";

const initEndingMembershipsTable = [
  { title: "שם מלא", field: "fullName" },
  { title: 'דוא"ל', field: "email" },
  { title: "סיום מנוי", field: "endOfSubscription" },
  { title: "מספר כרטיס", field: "belongToCardNum" },
  { title: "סוג מנוי", field: "membershipType" },
  { title: "תאריך יצירה", field: "dateCreated" }
  // softwareServiceType;
];

const initOfficesEndingMembershipsTable = [
  { title: "שם משרד", field: "officeName" },
  { title: "מספר כרטיס/משרד", field: "belongToCardNum" },
  { title: "סיומיי מינויים", field: "OfficeEdingMembershipsCount" }
];

export default function EndingMemberships(props) {
  const [state, setstate] = useState({ startDate: moment().format("YYYY-MM-DD"), endDate: moment().add(1, "months").format("YYYY-MM-DD") });
  const [endingMemberships, setEndingMemberships] = useState(null);
  const [filteredRows, setFilteredRows] = useState(null);
  const [showEndingMembershipsPerOfficeAndNotPerUsers, setShowEndingMembershipsPerOfficeAndNotPerUsers] = useState(false);

  useEffect(() => {
    if (!endingMemberships) return;
    return showEndingMembershipsPerOfficeAndNotPerUsers
      ? setFilteredRows(getOfficeRows(endingMemberships))
      : setFilteredRows(endingMemberships);
  }, [endingMemberships, showEndingMembershipsPerOfficeAndNotPerUsers]);

  return (
    <div>
      <Card className="width100">
        <CardContent>
          <h4 className="yellow-color">סיומי מנויים</h4>

          <div className="mt-50">
            <div className="inline-block">
              <div>תחילת חיפוש</div>
              <input id="startDate" onChange={handleChange} className="date-field padding13" type="date" value={state.startDate} />
            </div>

            <div className="mr-20 inline-block">
              <div>סוף חיפוש</div>
              <input id="endDate" onChange={handleChange} className="date-field padding13" type="date" value={state.endDate} />
            </div>

            <div className="mr-20 inline-block">
              <Button onClick={() => setXdaysToTheFuture(10)} color="secondary" variant="contained">
                10 ימים קדימה
              </Button>
            </div>

            <div className="mr-20 inline-block">
              <Button onClick={() => setXdaysToTheFuture(30)} color="secondary" variant="contained">
                30 ימים קדימה
              </Button>
            </div>

            <div className="mr-20 inline-block">
              <Button onClick={() => setXdaysToTheFuture(60)} color="secondary" variant="contained">
                60 ימים קדימה
              </Button>
            </div>
            <div className="mr-20 inline-block">
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={() => {
                      setShowEndingMembershipsPerOfficeAndNotPerUsers(!showEndingMembershipsPerOfficeAndNotPerUsers);
                    }}
                  />
                }
                label="איחוד לפי משרדים"
              />
            </div>
          </div>
          <div className="mt-20">
            <Button onClick={getEndingMemberships} color="primary" variant="contained">
              הצג
            </Button>
          </div>

          {filteredRows ? (
            <div>
              <MaterialTableComponent
                useDataAndColumnsFromProps
                data={filteredRows}
                columns={showEndingMembershipsPerOfficeAndNotPerUsers ? initOfficesEndingMembershipsTable : initEndingMembershipsTable}
                tableTitle="סיומי מנויים"
                redirectToSpecificUser={redirectToSpecificUser}
                enableRedirectMiddleClick
              />
            </div>
          ) : null}
        </CardContent>
      </Card>
    </div>
  );

  function handleChange(e) {
    const getState = { ...state };
    getState[e.target.id] = e.target.value;
    setstate(getState);
    setEndingMemberships(null);
  }

  function setXdaysToTheFuture(x) {
    const getState = { ...state };
    getState.startDate = moment().format("YYYY-MM-DD");
    getState.endDate = moment().add(x, "days").format("YYYY-MM-DD");
    setstate(getState);
    setEndingMemberships(null);
  }

  function getEndingMemberships() {
    if (!state.startDate || !state.endDate) return;
    adminService.getEndingMemberships(state).then((res) => {
      if (res.success) {
        const dataForUi = res.endingMemberships.map((x) => {
          if (!x.fullName) x.fullName = (x.firstName || "") + " " + (x.lastName || "");
          x.dateCreated = moment(x.dateCreated).format("DD-MM-YYYY");
          x.endOfSubscription = moment(x.endOfSubscription).format("DD-MM-YYYY");
          return x;
        });
        setEndingMemberships(dataForUi);
      }
    });
  }

  function redirectToSpecificUser(memberData, e) {
    const shouldOpenInNewTab = e.ctrlKey || e.metaKey || e.button === 1;
    adminService.getUsersBySearchKey(memberData.belongToCardNum).then((res) => {
      if (res["success"]) {
        const cardData = res["usersList"][0];
        if (shouldOpenInNewTab) window.open("/admin/specific-user/" + cardData._id, "_blank");
        else props.history.push("/admin/specific-user/" + cardData._id);
      }
    });
  }

  //calculate office ending memberships from users (can be one office for several users) ending memberships
  //each office has a count of how many users have ending memberships
  function getOfficeRows(usersEndingMemberships) {
    //collect all users into the offices by cardNum obj
    const officesByCardNum = usersEndingMemberships.reduce((acc, currentUserMembership) => {
      if (!acc[currentUserMembership.belongToCardNum]) acc[currentUserMembership.belongToCardNum] = [];
      acc[currentUserMembership.belongToCardNum].push(currentUserMembership);
      return acc;
    }, {});
    //map the offices obj into array of offices objs with wanted properties
    const officesEndingMemberships = Object.keys(officesByCardNum).map((officeCardNum) => {
      return {
        belongToCardNum: officeCardNum,
        OfficeEdingMembershipsCount: officesByCardNum[officeCardNum].length,
        officeName: officesByCardNum[officeCardNum]?.[0]?.officeName
      };
    });
    return officesEndingMemberships;
  }
}
